import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { validateInputText } from "../../../utilities/ValidateUtil";
import { DialogConfirm, DialogDelete } from "../../../components/DialogService/DialogService";
import { FooterButtonSigleCustom, FooterButtonCustomLabel } from "../../../components/FooterButton/FooterButton";
import { Loading } from "../../../components/Loading/Loading";
import ValidateService from "../../../components/ValidateService/ValidateService";

// SERVICE
import { pCtContractRouteUpdate } from "../../../service/400/P413Service";

export default function P413({ dialog, setDialog, onGetpCtContractInfo }) {
    const [errData, setErrData] = useState(null);
    const [formObject, setformObject] = useState({ contractNo: "", routeNo: 0, routeName: "", pipeLength: "", routeAmount: "", routePlanNo: "", requestNo: "", areaOwner: "", areaSurface: "" });
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);

    // DIALOG
    const [deleteDialog, setDeleteDialog] = useState(false);
    const [confirmDialog, setConfirmDialog] = useState(false);
    const [dialogOption, setdialogOption] = useState({
        header: "",
        content: "",
        onConfirm: () => {},
        onCancle: () => {},
        footerBtn: () => {},
    });

    useEffect(() => {
        if (dialog.dialog_413.open === true) {
            setformObject({ ...formObject, ...dialog.dialog_413.dataSet, userId: dialog.dialog_413.userId, contractNo: dialog.dialog_413.contractNo });
        }
    }, []);

    const setViewForm = (key) => {
    
        return formObject[key] === "" || formObject[key] === null ? "" : formObject[key];
    };

    const setValueForm = (key, val) => {
        setformObject({ ...formObject, [key]: val });
    };

    const validation = (object, act) => {
        console.log("object.routeNo: ", object.routeNo)
        if (act === "D") {
            return true;
        } else {
            if ((object.routeNo === 0 || object.routeNo === null )|| object.routeName === "" || object.requestNo === "") {
                setSubmitted(true);
                return false;
            } else {
                setSubmitted(false);
                return true;
            }
        }
    };
    const handlerCloseDialog = () => {
        setDialog({ ...dialog, dialog_413: { open: false, action: "", dataSet: null } });
    };
    const handlerSettingDialogConfirm = (header, content) => {
        setdialogOption({
            ...dialogOption,
            header: header,
            content: content,
            footerBtn: () => footerButtonSingle(),
            onCancle: () => setConfirmDialog(false),
        });
        setConfirmDialog({ open: true });
    };

    const submitForm = (act) => {
        if (validation(formObject, act)) {
            const req = {
                actionCode: act,
                areaOwner: setViewForm("areaOwner"),
                areaSurface: setViewForm("areaSurface"),
                contractNo: setViewForm("contractNo"),
                pipeLength: formObject.pipeLength === null ? 0.00 : parseFloat(formObject.pipeLength.replace("+",".")),
                requestNo: setViewForm("requestNo"),
                routeAmount: formObject.routeAmount === null  ? 0.00 :parseFloat(formObject.routeAmount),
                routeName: setViewForm("routeName"),
                routeNo: setViewForm("routeNo"),
                routePlanNo: setViewForm("routePlanNo"),
                userId: setViewForm("userId"),
            };

            pCtContractRouteUpdate(req).then(
                (res) => {
                    setLoading(false);
                    handlerSettingDialogConfirm(res[0].statusCode === "C" ? "" : "", res[0].statusText);
                },
                function (err) {
                    setLoading(false);
                    setErrData(err);
                }
            );
        }
    };

    const onHide = () => {
        handlerCloseDialog();
        setformObject({});
    };

    const footerButton = () => {
        const handlerDeleteData = () => {
            submitForm("D");
            setDeleteDialog(false);
        };
        return <FooterButtonCustomLabel labelCon="ยืนยัน" lableCan="ยกเลิก" onClickOk={() => handlerDeleteData()} onClickCancle={() => setDeleteDialog(false)} />;
    };

    const footerButtonSingle = (orNo) => {
        const con = () => {
            handlerCloseDialog();
            onGetpCtContractInfo();
        };
        return <FooterButtonSigleCustom btnLabel="ตกลง" icon="pi pi-check" onClick={() => con()} />;
    };
    const renderFooter = () => {
        return (
            <div style={{ textAlign: "right" }}>
                <Button label="บันทึก" icon="pi pi-save" onClick={() => submitForm(dialog.dialog_413.action === "EDIT" ? "U" : "A")} className="p-button-success p-button" />
                <Button label="ยกเลิก" icon="pi pi-ban" onClick={() => handlerCloseDialog()} className="p-button-danger p-button" />
                <Button label="ลบรายการ" icon="pi pi-trash" onClick={() => setDeleteDialog({ open: true })} className="p-button-danger p-button" disabled={dialog.dialog_413.action === "EDIT" ? false : true} />
            </div>
        );
    };
    return (
        <>
            <ValidateService err={errData} setErr={setErrData} />
            <Loading loading={loading} />

            <Dialog header="เส้นทาง" visible={dialog.dialog_413.open} style={{ width: "55vw" }} footer={renderFooter()} onHide={() => onHide()} blockScroll={true} className="p-fluid" maximizable={true}>
                <div className="p-grid" style={{ marginBottom: 30 }}>
                    <div className="p-col-12">
                        <label>เลขที่สัญญา</label>
                        <InputText id="contractNo" value={setViewForm("contractNo")} maxLength={20} disabled={true} />
                    </div>
                    <div className="p-col-6">
                        <label>
                            เส้นทาง<span style={{ color: "red" }}>*</span>
                        </label>
                        <InputNumber placeholder="ระบุ เส้นทาง" className={submitted && !formObject.routeNo ? "p-invalid" : ""} id="pipeLength" value={setViewForm("routeNo")} onValueChange={(e) => setValueForm("routeNo", e.value)} useGrouping={false} min={0} max={100} />
                        {submitted && !formObject.routeNo && validateInputText("routeNo", "เส้นทาง")}
                    </div>
                    <div className="p-col-6">
                        <label>
                            สถานที่<span style={{ color: "red" }}>*</span>
                        </label>
                        <InputText placeholder="ระบุ สถานที่" className={submitted && !formObject.routeName ? "p-invalid" : ""} id="routeName" value={setViewForm("routeName")} onChange={(e) => setValueForm("routeName", e.target.value)} maxLength={200} />
                        {submitted && !formObject.routeName && validateInputText("routeName", "สถานที่")}
                    </div>
                    <div className="p-col-6">
                        <label>ความยาวรวม(ม.)</label>
                        <InputText placeholder="ระบุ ความยาวรวม(ม.)" id="pipeLength" value={setViewForm("pipeLength")} onChange={(e) => setValueForm("pipeLength", e.target.value)}  maxLength={11}  keyfilter={/\d|[+]/}/>
                    </div>
                    <div className="p-col-6">
                        <label>มูลค่าเส้นทาง(บาท)</label>
                        <InputNumber placeholder="ระบุ มูลค่าเส้นทาง(บาท)" id="routeAmount" value={setViewForm("routeAmount")} onValueChange={(e) => setValueForm("routeAmount", e.value)} useGrouping={false} max={999999999999999} mode="decimal" />
                    </div>
                    <div className="p-col-6">
                        <label>เลขที่แบบแปลน</label>
                        <InputText placeholder="ระบุ เลขที่แบบแปลน" id="routePlanNo" value={formObject.routePlanNo} onChange={(e) => setValueForm("routePlanNo", e.target.value)} maxLength="500" />
                    </div>
                    <div className="p-col-6">
                        <label>
                            เลขที่คำร้อง<span style={{ color: "red" }}>*</span>
                        </label>
                        <InputText placeholder="ระบุ เลขที่คำร้อง" id="requestNo" className={submitted && !formObject.requestNo ? "p-invalid" : ""} value={formObject.requestNo} onChange={(e) => setValueForm("requestNo", e.target.value)} maxLength="500" />
                        {submitted && !formObject.requestNo && validateInputText("requestNo", "เลขที่คำร้อง")}
                    </div>
                    <div className="p-col-6">
                        <label>หน่วยงานเจ้าของโครงการ</label>
                        <InputText placeholder="ระบุ หน่วยงานเจ้าของโครงการ" id="areaOwner" value={formObject.areaOwner} onChange={(e) => setValueForm("areaOwner", e.target.value)} maxLength="500" />
                    </div>
                    <div className="p-col-6">
                        <label>ผิวจราจร</label>
                        <InputText placeholder="ระบุ ผิวจราจร" id="areaSurface" value={formObject.areaSurface} onChange={(e) => setValueForm("areaSurface", e.target.value)} />
                    </div>
                </div>
            </Dialog>
            <DialogDelete visible={deleteDialog.open} header="" modal footer={footerButton()} onHide={() => setDeleteDialog(false)} textContent="ยืนยันเพื่อลบรายการ หรือกดยกเลิกเพื่อยกเลิกการทำรายการ" />
            <DialogConfirm visible={confirmDialog.open} header={dialogOption.header} modal footer={dialogOption.footerBtn} onHide={() => setConfirmDialog(false)} textContent={dialogOption.content} />
        </>
    );
}
